"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.knowledge.title': '打开知识选择器',
    'shortcuts.knowledge.description': '打开知识选择器以搜索和选择知识源',
};
